import { useEffect, useRef } from 'react';
/** Returns the previous value of `variable` in a given render */
export function usePreviousValue(variable) {
    var ref = useRef(null);
    useEffect(function () {
        ref.current = variable;
    }, [variable]);
    // This happens before the update in useEffect, so it's effectively returning the previous value
    return ref.current;
}
//# sourceMappingURL=usePreviousValue.js.map